<template>
    <div class="p-2">
        <div class="container-fluid">
            <header>
                <h1>Visit Detail</h1>
            </header>

            <div class="row patient-summary">
                <div class="col-2">
                    <img class="headshot" :src="patientImageUrl"/>
                </div>
                <div class="col">
                    <h5><a @click.prevent="editPatient()" href="#">PATIENT SUMMMARY &nbsp;<font-awesome-icon size="1x" :icon="['far', 'edit']"/></a></h5>
                    <span class="field-label">Name: </span>{{ visit.firstName + ' ' + visit.lastName }}<br>
                    <span class="field-label">Birth Date: </span>{{ formatBirthDate(visit.dob) }}<br>
                    <span class="field-label">Service Type: </span>{{ visit.appointmentTypeText }}<br>
                    <span class="field-label">MRN: </span>{{ visit.mrn }}<br>
                    <span class="field-label">Patient ID: </span>{{ visit.patientIdFromOrg }}<br>
                    <span class="field-label">Phone: </span>{{ visit.phone }}<br>
                    <span class="field-label">E-Mail: </span>{{ visit.email }}<br>
                </div>
            </div>
        </div>
        <loading-modal :visible="showingLoadingModal" @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    </div>
</template>

<script>
  import api from '../services/api'
  import moment from 'moment'
  import LoadingModal from '../components/LoadingModal'

  export default {
    name: 'VisitDetail',

    components: { LoadingModal },

    props: {
      id: {
        default: 0
      }
    },

    data () {
      return {
        visit: {
          firstName: '',
          lastName: ''
        },
        patientImageUrl: '',
        showingLoadingModal: false
      }
    },

    watch: {
      // call again the method if the route changes
      $route: 'loadData'
    },

    computed: {

    },

    methods: {
      loadData () {
        this.loadVisit()
        this.loadImageUrl()
      },

      loadVisit () {
        this.showingLoadingModal = true

        api.get('/Dashboard/VisitDetail/' + this.id).then(response => {

          this.visit = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load appointments: ' + error.message, error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      loadImageUrl () {
        const placeholderUrl = 'https://s3.amazonaws.com/health-here-assets/Images/PhotoPlaceholder.jpg'
        api.get('/Dashboard/PatientPhoto/' + this.id).then(response => {

          if (response.data.url) {
            this.patientImageUrl = response.data.url
          } else {
            this.patientImageUrl = placeholderUrl
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load image url.', error)
          }
        })
      },

      editPatient () {

      },

      formatBirthDate (dob) {
        if (dob) {
          return moment(dob).utc().format('MM/DD/YYYY')
        } else {
          return ''
        }
      }

    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>
    .patient-summary {
        padding: 0.75rem;
        vertical-align: bottom;
        border-top: 1px solid #dee2e6;
        border-bottom: 2px solid #dee2e6;
        border-collapse: collapse;
        background-color: #f9f9f9;
    }

    .patient-summary h5 {
        font-weight: 600;
        color: #001859;
    }

    .patient-summary h5 a {
        font-weight: 600;
        color: #001859;
        text-decoration: none;
    }
</style>
